import { render, staticRenderFns } from "./shetai.vue?vue&type=template&id=65980763&scoped=true&"
import script from "./shetai.vue?vue&type=script&lang=ts&"
export * from "./shetai.vue?vue&type=script&lang=ts&"
import style0 from "./shetai.vue?vue&type=style&index=0&id=65980763&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65980763",
  null
  
)

export default component.exports